import React, { useState, useEffect } from "react";
import ProductCard from "./ProductCard";
import { useForm, Controller } from "react-hook-form";
import "./RecommendationsPage.css";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

function RecommendationPage() {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   dob: "",
  //   time_of_birth: "",
  //   location: "",
  // });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    watch
  } = useForm();
  const [suggestions, setSuggestions] = useState([]);
  const [recommendations, setRecommendations] = useState(null);
  const [isformvisible, setIsformvisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Watch for changes in location input
  const locationInput = watch("location");

  // Fetch location suggestions dynamically
  useEffect(() => {
    if (locationInput && locationInput.length > 1) {
      fetchLocationSuggestions(locationInput);
    } else {
      setSuggestions([]);
    }
  }, [locationInput]);

  const planetSymbols = {
    Sun: "☉",
    Moon: "☽",
    Mercury: "☿",
    Venus: "♀",
    Mars: "♂",
    Jupiter: "♃",
    Saturn: "♄",
    Rahu: "☊",
    Ketu: "☋"
  };

  // Function to fetch latitude & longitude from location
  const fetchCoordinates = async (location) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(location)}`
      );
      const data = await response.json();
      if (data.length > 0) {
        return {
          latitude: data[0].lat,
          longitude: data[0].lon,
        };
      } else {
        throw new Error("Location not found");
      }
    } catch (err) {
      throw new Error("Failed to fetch location coordinates");
    }
  };

  // Handle input change
  // const handleInputChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });

  //   if (e.target.name === "location" && e.target.value.length > 1) {
  //     fetchLocationSuggestions(e.target.value);
  //   } else {
  //     setSuggestions([]);
  //   }
  // };

  // Fetch location suggestions for autocomplete
  const fetchLocationSuggestions = async (query) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&countrycodes=in`
      );
      const data = await response.json();
    console.log("data", data);
      setSuggestions(data);
    } catch (err) {
      console.error("Error fetching location suggestions:", err);
    }
  };

  // Handle selecting a location from suggestions
  // const handleSelectLocation = async (location) => {
  //   setFormData({ ...formData, location: location.display_name });
  //   setSuggestions([]); 
  // };


  const onSubmit = async (data) => {
    setLoading(true);
    setError(null);

    try {
      const { latitude, longitude } = await fetchCoordinates(data.location);

      const response = await fetch(
        `${API_BASE_URL}/product/vastu_recommendations/?name=${data.name}&dob=${data.dob}&time_of_birth=${data.time_of_birth}&latitude=${latitude}&longitude=${longitude}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch recommendations");
      }

      const responseData = await response.json();
      console.log("data", responseData);

      const recommendedProducts = [];
      if (responseData.remedies) {
        Object.entries(responseData.remedies).forEach(([planet, remedyTypes]) => {
          Object.entries(remedyTypes).forEach(([remType, product]) => {
            if (product?.id) {
              let selectedImage =
                product.documents
                  .find((doc) => doc.is_current)?.picture
                  ?.split("/product_picture/")[1] ||
                product.documents[0]?.picture?.split("/product_picture/")[1] ||
                "https://via.placeholder.com/300";

              selectedImage = selectedImage ? `product_picture/${selectedImage}` : "https://via.placeholder.com/300";

              recommendedProducts.push({
                id: product.id,
                name: product.name,
                image: selectedImage,
                tagline: `${planet} - ${remType}`,
                currentPrice: parseFloat(product.actual_unit_price),
                originalPrice: parseFloat(product.unit_price),
                discount: product.discount,
                labels: product.tags.map((tag) => tag.name),
              });
            }
          });
        });
      }

      setRecommendations({ ...responseData, recommendedProducts });
      if (response.ok) {
        setIsformvisible(false);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >
      {isformvisible && (
        <div className="">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8">
                <div className="">
                  <h2 className="recommendation-heading">Get Your Vastu Product Recommendations</h2>
                  <form className="recommendation-form" onSubmit={handleSubmit(onSubmit)}>
                    {/* Name Input */}
                    <label>
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      {...register("name", { required: "Name is required" })}
                      placeholder="Enter your name"
                    />
                    {errors.name && <p className="error-message">{errors.name.message}</p>}

                    {/* Date of Birth Input */}
                    <label>
                      Date of Birth <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="date"
                      {...register("dob", { 
                        required: "Date of Birth is required",
                        validate: value => value <= new Date().toISOString().split("T")[0] || "Future dates are not allowed"
                      })}
                      max={new Date().toISOString().split("T")[0]} 
                      placeholder="Select your date of birth"
                    />
                    {errors.dob && <p className="error-message">{errors.dob.message}</p>}

                    {/* Time of Birth Input */}
                    <label>
                      Time of Birth <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="time"
                      {...register("time_of_birth", { required: "Time of Birth is required" })}
                      placeholder="Enter your time of birth"
                    />
                    {errors.time_of_birth && <p className="error-message">{errors.time_of_birth.message}</p>}

                    {/* Location Input with Autocomplete */}
                    <label>
                      Place of Birth<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <Controller
                        name="location"
                        control={control}
                        rules={{ required: "Location is required" }}
                        render={({ field }) => (
                          <input
                            type="text"
                            {...field}
                            placeholder="Enter location (City, Country)"
                          />
                        )}
                      />
                      {errors.location && <p className="error-message">{errors.location.message}</p>}

                      {suggestions.length > 0 && (
                        <ul
                          style={{
                            listStyleType: "none",
                            padding: 0,
                            margin: 0,
                            border: "1px solid #ccc",
                            maxHeight: "150px",
                            overflowY: "auto",
                            position: "absolute",
                            background: "white",
                            width: "100%",
                            zIndex: 1000,
                          }}
                        >
                          {suggestions.map((item) => (
                            <li
                              key={item.place_id}
                              onClick={() => {
                                setValue("location", item.display_name); // Set selected location
                                setSuggestions([]); // Clear suggestions after selection
                              }}
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              {item.display_name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    {/* Submit Button */}
                    <button type="submit" disabled={loading}>
                      {loading ? "Loading..." : "Show Recommendations"}
                    </button>
                  </form>
                </div>
            </div>
          </div>
        </div>
      )}

      {error && <p className="error">{error}</p>}

      {recommendations && !isformvisible && (
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row justify-content-center">
              <div className="d-flex justify-content-center align-items-center">
                {/* <h2 className="flex-grow-1 text-center">Your Vastu Product Recommendations</h2> */}
                <button 
                  onClick={() => setIsformvisible(true)} 
                  className="btn btn-warning" 
                  data-bs-toggle="tooltip" 
                  data-bs-placement="top" 
                  title="Edit your search details"
                >
                  Edit your details
                </button>
              </div>


                <div className="col-md-6 text-center">
                  <h3>Your Astrological Signs</h3>
                  <p >
                    🌞 Sun Sign: <strong>{recommendations.sun_sign}</strong>
                  </p>
                  <p >
                    🌙 Moon Sign: <strong>{recommendations.moon_sign}</strong>
                  </p>
                  <p >
                    🌍 Ascendant: <strong>{recommendations.ascendant}</strong>
                  </p>
                  <p >
                    ⭐ Nakshatra: <strong>{recommendations.nakshatra}</strong>
                  </p>
                </div>
                <div className="col-md-6 text-center">
                  <h3>Weak Planets</h3>
                  {recommendations.weak_planets && recommendations.weak_planets.length > 0 && (
                    recommendations.weak_planets.map((planet, index) => (
                      <p key={index} className="d-inline-block p-2 card shadow m-2">
                        <span>{planet} </span>: {planetSymbols[planet] || "❓"}
                      </p>
                    ))
                  )}
                </div>
                <div className="col">
                  <h3>Characteristics</h3>
                  <p className="text-start card shadow d-inline-block p-2"><strong className="d-flow">Personality </strong> : {recommendations.user_characteristics.core_personality}</p>
                  <p className="text-start card shadow d-inline-block p-2"><strong className="d-flow">Nature </strong> : {recommendations.user_characteristics.emotional_nature}</p>
                  <p className="text-start card shadow d-inline-block p-2"><strong className="d-flow">Behavior </strong> : {recommendations.user_characteristics.outer_behavior}</p>
                </div>
              </div>
            </div>
            {/* <h3>Your Astrological Signs</h3>
            <p>
              🌞 Sun Sign: <strong>{recommendations.sun_sign}</strong>
            </p>
            <p>
              🌙 Moon Sign: <strong>{recommendations.moon_sign}</strong>
            </p>
            <p>
              🌍 Ascendant: <strong>{recommendations.ascendant}</strong>
            </p>
            <p>
              ⭐ Nakshatra: <strong>{recommendations.nakshatra}</strong>
            </p> */}

            {/* <h3>Weak Planets</h3>
            <p>{recommendations.weak_planets.join(", ")}</p> */}
            <div className="col-lg-10">
              <h3 className="text-center">Recommended Products</h3>
              <div className="products-container">
                <div className="row justify-content-center align-item-center w-auto flex-wrap gap-3">
                  {recommendations.recommendedProducts.length > 0 ? (
                    recommendations.recommendedProducts.map((product) => (
                      <ProductCard key={product.id} product={product} />
                    ))
                  ) : (
                    <p>No recommended products available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RecommendationPage;
